<template>
  <div class="imprint-container">
    <div v-if="companyStore.getCompany && !companyStore.isBusy">
      <h2 v-if="showTitle">
        {{ t("Imprint:") }}
      </h2>
      <!-- eslint-disable vue/no-bare-strings-in-template -->
      <span v-if="companyStore.isCombinator" class="ch">
        Combinator AG <br />
        Samstagernstrasse 55<br />
        8832 Wollerau<br />
        {{ t("Switzerland") }}<br />
      </span>
      <p v-else-if="companyStore.isEEI" class="eei-imprint">
        EEI SOLUTIONS LLC<br />
        PO BOX 63333<br />
        PHOENIX, AZ 85082<br />
        USA<br />
        info (@) ersties.com<br />
        Entity ID: A2003043
      </p>
      <p v-else class="efc-imprint">
        EFC GmbH<br />
        Sonnenhof 3<br />
        8808 Pfäffikon<br />
        {{ t("Switzerland") }}
      </p>

      <template v-if="!companyStore.isEEI">
        <p class="email">
          {{ t("info (at) ersties.com") }}
        </p>

        <span v-if="showFinancial && !companyStore.isCombinator" class="financial">
          <p>
            Commercial register Schwyz<br />
            CH-130.4.022.544-5
          </p>
        </span>
      </template>
      <!-- eslint-enable vue/no-bare-strings-in-template -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount } from "vue";
import { useCompanyStore } from "@/store/company";
import { useI18n } from "vue-i18n";

defineOptions({
  name: "imprint",
});

defineProps({
  showFinancial: {
    type: Boolean,
    default: true,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
});
const { t } = useI18n();

const companyStore = useCompanyStore();

onBeforeMount(async () => {
  await companyStore.defineCompany();
});
</script>

<style lang="scss">
@import "./index";
</style>
